import { useQuery } from "@tanstack/react-query";
import type { StoreSubscriptionPaymentView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseStoreSubscriptionPaymentsQueryParams = {
  storeId: string;
};

/**
 * Every payment on the store, newest first — recorded, requested, rejected
 * and reversed alike. There is no archived variant any more: a payment is
 * never deleted, only reversed, and a reversed one stays in this list.
 */
export function useStoreSubscriptionPaymentsQuery({
  storeId,
}: UseStoreSubscriptionPaymentsQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.admin.storeSubscriptionPayments(storeId),
    queryFn: () =>
      apiJsonClient<StoreSubscriptionPaymentView[]>(
        endpoints.admin.storeSubscriptionPayments(storeId),
      ),
    enabled: storeId.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
